module.exports = { "default": require(25), __esModule: true };